import { render, staticRenderFns } from "./chat-question.vue?vue&type=template&id=8f5c529e&"
import script from "./chat-question.vue?vue&type=script&lang=js&"
export * from "./chat-question.vue?vue&type=script&lang=js&"
import style0 from "./chat-question.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "chat-question.vue"
export default component.exports